import React, { FC } from 'react';
import { Box } from '@material-ui/core';
import UserMenu from '../UserMenu';
import AppBarLogo from './AppBarLogo';
import AppBarWrapper from './AppBarWrapper';
import { useUser } from '../../../shared';
import { ContactMenu } from '../../../support';
import { useAppSelector } from 'src/modules/shared/hooks/useAppDispatch';
import { NotificationsIconMenu } from '../Notifications/IconMenu/NotificationsIconMenu';
import AppBarPopoverDemo from './components/AppBarPopoverDemo.tsx/AppBarPopoverDemo';

const AppBar: FC = () => {
  const { isTeacher } = useUser();
  const showPresentationMode = useAppSelector(
    (state) => state.presentationMode.showPresentationMode
  );

  if (showPresentationMode) return null;

  return (
    <AppBarWrapper>
      <div style={{ display: 'flex', gap: 8, alignItems: 'end' }}>
        <AppBarLogo />
        <AppBarPopoverDemo />
      </div>
      <Box flex={1} />
      <div style={{ display: 'flex', gap: '16px' }}>
        {isTeacher && <ContactMenu />}
        <NotificationsIconMenu />
        <UserMenu className="hide-on-print" />
      </div>
    </AppBarWrapper>
  );
};

export default AppBar;
